import { render } from "./dealerGroups.vue?vue&type=template&id=386356a2"
import script from "./dealerGroups.vue?vue&type=script&lang=js"
export * from "./dealerGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__